import React from 'react';
import { Navigate } from 'react-router-dom';

// This page is deprecated - RetreatLandingPage now handles center and camp selection
export default function RetreatsPage() {
  return <Navigate to="/retreat" replace />;
}
